import type { SVGProps } from "react";
const SenecPictogramContact = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M24 11C24 9.34315 25.3431 8 27 8H39C40.6569 8 42 9.34315 42 11V13C42 13.5523 41.5523 14 41 14C40.4477 14 40 13.5523 40 13V11C40 10.4477 39.5523 10 39 10H27C26.4477 10 26 10.4477 26 11V17.3333L24 20H39C39.5523 20 40 19.5523 40 19V18C40 17.4477 40.4477 17 41 17C41.5523 17 42 17.4477 42 18V19C42 20.6569 40.6569 22 39 22H20L24 16.6667V11Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 18C8 14.6863 10.6863 12 14 12C17.3137 12 20 14.6863 20 18C20 21.3137 17.3137 24 14 24C10.6863 24 8 21.3137 8 18ZM14 14C11.7909 14 10 15.7909 10 18C10 20.2091 11.7909 22 14 22C16.2091 22 18 20.2091 18 18C18 15.7909 16.2091 14 14 14Z"
            fill="currentColor"
        />
        <path d="M30 16H28V14H30V16Z" fill="currentColor" />
        <path d="M34 16H32V14H34V16Z" fill="currentColor" />
        <path d="M38 16H36V14H38V16Z" fill="currentColor" />
        <path
            d="M14 28C10.6863 28 8 30.6863 8 34V40C8 40.5523 7.55228 41 7 41C6.44772 41 6 40.5523 6 40V34C6 29.5817 9.58172 26 14 26C18.4183 26 22 29.5817 22 34V40C22 40.5523 21.5523 41 21 41C20.4477 41 20 40.5523 20 40V34C20 30.6863 17.3137 28 14 28Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramContact;
